import useAxios from './useAxios';
import { DateObject } from '../objects/models/date.field.value';
import getDateStringFromObject from '../functions/getDateStringFromObject';
import { stripInvalidMbiChars } from '../functions/stripInvalidMbiChars';
import { ApiError } from '../functions/getApiErrorMessage';

export interface VerifyAccountResponse {
    code: number
    username: string
    createdAt: number
    errors?: ApiError[]
}

export default function useVerifyAccountApi() {
    const axios = useAxios();

    const post = async (medicareNumber: string, lastName: string, dateOfBirth: DateObject) => {
        return axios.call<VerifyAccountResponse>(
            'POST',
            '/account/api/verify-account',
            {
                dateOfBirth: getDateStringFromObject(dateOfBirth),
                lastName,
                mbi: stripInvalidMbiChars(medicareNumber),
            },
        );
    };

    return {
        post,
    };
}
